import MathSymbolsPicker from './MathSymbolsPicker';

export default MathSymbolsPicker; 